import React from 'react';
import BubbleChart from '@weknow/react-bubble-chart-d3';

export default function BubbleChartComponent(props) {
    const data = props.data?.map(startup => {
        return { label: startup.name, value: startup.contracts };
    });

    const totalValue = data?.reduce((initialValue, currStartup) => {
        return initialValue + currStartup.value;
    }, 0);

    const bubbleValues = data?.map(bubble => {
        return bubble.value;
    });

    const maxDataValue = Math.max.apply(Math, bubbleValues);
    const minDataValue = Math.min.apply(Math, bubbleValues);
    const averageDataValue = Number((totalValue / bubbleValues?.length).toFixed(0));
    const thirdDataValue = Number(((maxDataValue + minDataValue) / 3).toFixed(0));
    const fourthDataValue = Number(((maxDataValue + minDataValue) / 4).toFixed(0));

    const colorizedData = data?.map(bubble => {
        if (bubble.value === maxDataValue) bubble.color = '#290493';
        if (bubble.value < maxDataValue && bubble.value >= averageDataValue)
            bubble.color = '#279DB4';
        if (bubble.value < averageDataValue && bubble.value >= thirdDataValue)
            bubble.color = '#0094F9';
        if (bubble.value < thirdDataValue && bubble.value >= fourthDataValue)
            bubble.color = '#53F4FF';
        if (bubble.value < fourthDataValue && bubble.value >= minDataValue)
            bubble.color = '#B7B7B7';
        return bubble;
    });

    return colorizedData.length > 0 ? (
        <BubbleChart
            graph={{
                zoom: 0.5,
                offsetX: 0.55,
                offsetY: 0.45,
            }}
            padding={0} // optional value, number that set the padding between bubbles
            showLegend={true} // optional value, pass false to disable the legend.
            legendPercentage={50} // number that represent the % of with that legend going to use.
            showValue={true}
            legendFont={{
                size: 15,
                color: '#000',
                weight: 'regular',
            }}
            valueFont={{
                size: 15,
                color: '#fff',
                weight: 'bold',
            }}
            labelFont={{
                size: 13,
                color: '#fff',
                weight: 'bold',
            }}
            //Custom bubble/legend click functions such as searching using the label, redirecting to other page
            data={colorizedData}
        />
    ) : null;
}
